// Algebra reference sheet — quick-lookup formulas and rules, as opposed to
// the instructional walkthroughs with worked examples in the Math domain
// guide. Keep entries short: a formula or rule, not a lesson. Paragraphs are
// plain strings or structured blocks { type: 'steps' | 'list', ... }.

export const documentTitle = 'Algebra Reference';
export const documentSlug = 'algebra-reference';

export const parts = [
  {
    id: 'algebra-reference-full',
    title: null,
    sections: [
      {
        id: 'ar-linear-forms',
        heading: 'Forms of a Linear Equation',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Slope-intercept form: y = mx + b (m = slope, b = y-intercept)',
              'Point-slope form: y - y₁ = m(x - x₁)',
              'Standard form: Ax + By = C',
              'Slope between two points: m = (y₂ - y₁) / (x₂ - x₁)',
            ],
          },
        ],
      },
      {
        id: 'ar-solving',
        heading: 'Solving Linear Equations and Inequalities',
        paragraphs: [
          {
            type: 'steps',
            steps: [
              'Distribute any parentheses first.',
              'Combine like terms.',
              'Undo addition/subtraction before multiplication/division.',
            ],
          },
          'Multiplying or dividing both sides of an inequality by a negative number flips the inequality sign.',
        ],
      },
      {
        id: 'ar-systems',
        heading: 'Systems of Two Linear Equations',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Different slopes: exactly one solution',
              'Same slope, different intercept (parallel lines): no solution',
              'Same slope and same intercept (the same line): infinitely many solutions',
            ],
          },
          'Solve by substitution or elimination.',
        ],
      },
      {
        id: 'ar-inequalities-two-var',
        heading: 'Graphing Linear Inequalities',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Dashed boundary line for strict inequalities (< or >); solid boundary line for ≤ or ≥',
              'Test a point not on the line (the origin is usually easiest) to determine which side to shade',
              'A system of inequalities is satisfied wherever the shaded regions overlap',
            ],
          },
        ],
      },
    ],
  },
];
